/// <reference path="shopify.d.ts" />

// 入口函数，在页面加载完成后执行
function main() {
  Alpine.store('localization', {
    country: window.Shopify.country,
    language: window.Shopify.locale,
    regions: [
      {
        region: 'Common',
        languages: [
          {
            country_name: 'United States',
            country_code: 'US',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '$',
            currency_code: 'USD',
          },
          {
            country_name: 'Deutschland',
            country_code: 'DE',
            language_name: 'Deutsch',
            language_code: 'de',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Japan',
            country_code: 'JP',
            language_name: '日本语',
            language_code: 'ja',
            currency_symbol: '¥',
            currency_code: 'JPY',
          },
        ],
      },
      {
        region: 'Europe',
        languages: [
          {
            country_name: 'Ireland',
            country_code: 'IE',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Estonia',
            country_code: 'EE',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Austria',
            country_code: 'AT',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Bulgaria',
            country_code: 'BG',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Belgium',
            country_code: 'BE',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Poland',
            country_code: 'PL',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'United Kingdom',
            country_code: 'GB',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '£',
            currency_code: 'GBP',
          },
          {
            country_name: 'Denmark',
            country_code: 'DK',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Deutschland',
            country_code: 'DE',
            language_name: 'Deutsch',
            language_code: 'de',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'France',
            country_code: 'FR',
            language_name: 'Français',
            language_code: 'fr',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Netherlands',
            country_code: 'NL',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Czech Republic',
            country_code: 'CZ',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Croatia',
            country_code: 'HR',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Latvia',
            country_code: 'LV',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Lithuania',
            country_code: 'LT',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Romania',
            country_code: 'RO',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Luxembourg',
            country_code: 'LU',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Malta',
            country_code: 'MT',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Norway',
            country_code: 'NO',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Portugal',
            country_code: 'PT',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Sweden',
            country_code: 'SE',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Switzerland',
            country_code: 'CH',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Cyprus',
            country_code: 'CY',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Slovenia',
            country_code: 'SI',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Hungary',
            country_code: 'HU',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Spain',
            country_code: 'ES',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Greece',
            country_code: 'GR',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Italy',
            country_code: 'IT',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Finland',
            country_code: 'FI',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
          {
            country_name: 'Slovakia',
            country_code: 'SK',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '€',
            currency_code: 'EUR',
          },
        ],
      },
      {
        region: 'Americas',
        languages: [
          {
            country_name: 'Canada',
            country_code: 'CA',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '$',
            currency_code: 'USD',
          },
          {
            country_name: 'United States',
            country_code: 'US',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '$',
            currency_code: 'USD',
          },
        ],
      },
      {
        region: 'Asia Pacific',
        languages: [
          {
            country_name: 'Australia',
            country_code: 'AU',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '$',
            currency_code: 'USD',
          },
          {
            country_name: 'Japan',
            country_code: 'JP',
            language_name: '日本语',
            language_code: 'ja',
            currency_symbol: '¥',
            currency_code: 'JPY',
          },
          {
            country_name: 'Malaysia',
            country_code: 'MY',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '$',
            currency_code: 'USD',
          },
          // {
          //   country_name: 'Thailand',
          //   country_code: 'TH',
          //   language_name: 'English',
          //   language_code: 'en',
          //   currency_symbol: '$',
          //   currency_code: 'USD',
          // },
          {
            country_name: 'Philippines',
            country_code: 'PH',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '$',
            currency_code: 'USD',
          },
          {
            country_name: 'Singapore',
            country_code: 'SG',
            language_name: 'English',
            language_code: 'en',
            currency_symbol: '$',
            currency_code: 'USD',
          },
        ],
      },
    ],

    current: null,
    get currentStr() {
      if (!this.current) {
        return ""
      }

      return `${this.current.country_name} ( ${this.current.language_name} / ${this.current.currency_symbol} ${this.current.currency_code} ) `
    },

    showDiscountCode(curr) {
      if (!this.current) {
        return ""
      }

      
      return true;
      // if (this.current.currency_code == curr) {
      //   return true;
      // } else {
      //   return false;
      // }
    },

    init() {
      this.resetCurrent()
    },

    postLang() {

    },

    // 设置插件的币种
    async setLang(language) {
      return new Promise(async (resolve, reject) => {
        const data = {
          form_type: 'localization',
          // 国家必须设置，防止插件匹配不上国家导致重定向
          country_code: language.country_code,
          locale_code: language.language_code,
          _method: 'PUT',
          utf8: true
        }
        const body = new FormData()
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            const value = data[key];
            body.append(key, value)
          }
        }
        const res = await fetch("/localization", {
          "method": "POST",
          "mode": "cors",
          "credentials": "include",
          body: body
        })
        
        // hack 重写onreadystatechange 不让插件调用请求
        window.XMLHttpRequest = class extends window.XMLHttpRequest {
          constructor() {
            super()
          }
          onreadystatechange() {
            console.log("readyState");
          }

          onerror(e) {
            console.log("error");
            reject(e)
          }

          send() {
            resolve()
          }
        }
        
        setTimeout(() => {
          if (res.url) {
            location.href = res.url
          }
        }, 5000)

        this.triggerWSSCC(language)
      })
    },

    // 触发插件
    triggerWSSCC(language) {
      console.log(language);
      
      const code = language.country_code
      console.log(code);
      
      // const item = document.querySelector(`.wsscc-drop-item .currency-flag-${code.toLowerCase()}`);
      // const item = document.querySelector(`.fflag-${code.toLowerCase()}`)
      const item = document.querySelector(`.wsscc-drop-item[data-code="${code}"]`);

      if (item) {
        document.querySelector("#wssccSelected").click()
        const target = item.closest(".wsscc-drop-item")
        target && target.click()
        return
      }

      const usd = document.querySelector(`.wsscc-drop-item .currency-flag-us`)
      if (usd) {
        document.querySelector("#wssccSelected").click()
        const target = usd.closest(".wsscc-drop-item")
        target && target.click()
      }
    },
 
    // 只判断国家，不判断语言。只要国家相同，就返回对应的region.language
    resetCurrent() {
      for (const region of this.regions) {
        const language = region.languages.find(language => language.country_code === this.country)
        if (language) {
          this.current = language
          return
        }
      }

      // default common region lang
      this.current = this.regions[0].languages[0]
    },

    showLanguageDialog() {
      publish(PUB_SUB_EVENTS.languageDialog, {
        data: {
          show: true,
        },
      });
    }
  })
}

document.addEventListener('alpine:init', main)
